'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

cbAlphanum.$inject = ['ValidationService'];


var _module = _angular2.default.module('cb.Alphanum', []);

_module.directive('cbAlphanum', cbAlphanum);

exports.default = _module;

/**
 * * cb-alphanum
*/

function cbAlphanum(ValidationService) {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function link(scope, element, attrs, ngModel) {
            function validator(value) {
                if (ngModel.$isEmpty(value)) {
                    return true;
                }

                if (attrs.cbAlphanum === 'alphanum-parel') {
                    return ValidationService.validateParelAlphanum(value);
                } else {
                    return ValidationService.validateAlphanum(value);
                }
            }

            ngModel.$validators['alphanum'] = validator;
        }
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/lib/core/forms/alphanum/cb-alphanum.directive.js
// module id = 775
// module chunks = 0